import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { FaqItem } from '../faq-item';
import * as Styled from './faq.style';

const faqs = [
  {
    questionKey: 'forms.onboarding.premium.faq.1.question',
    answerKey: 'forms.onboarding.premium.faq.1.answer',
  },
  {
    questionKey: 'forms.onboarding.premium.faq.2.question',
    answerKey: 'forms.onboarding.premium.faq.2.answer',
  },
  {
    questionKey: 'forms.onboarding.premium.faq.3.question',
    answerKey: 'forms.onboarding.premium.faq.3.answer',
  },
  {
    questionKey: 'forms.onboarding.premium.faq.4.question',
    answerKey: 'forms.onboarding.premium.faq.4.answer',
  },
  {
    questionKey: 'forms.onboarding.premium.faq.5.question',
    answerKey: 'forms.onboarding.premium.faq.5.answer',
  },
];

export const Faq: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Styled.FaqSection>
      <Typography variant="h4" component="h2">
        {t('forms.onboarding.premium.faq.title')}
      </Typography>

      <Styled.FaqList>
        {faqs.map(({ questionKey, answerKey }) => (
          <FaqItem
            key={questionKey}
            questionKey={questionKey}
            answerKey={answerKey}
          />
        ))}
      </Styled.FaqList>
    </Styled.FaqSection>
  );
};
